export default `
  mutation guestCreateCustomerId {
    guestCreateCustomerId {
      customer_id
      cookie_lifetime
    }
  }
`;
